import React, { useState, useContext, useEffect, useRef } from 'react';
import AuthContext from '../context/AuthContext';
import ReCAPTCHA from 'react-google-recaptcha';

const Login = (props) => {
  const { login, isAuthenticated, error } = useContext(AuthContext);
  const captchaRef = useRef(null);

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push('/');
    }
  }, [isAuthenticated, props.history]);

  const [formData, setFormData] = useState({
    identifier: '',
    password: ''
  });

  const { identifier, password } = formData;

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    const captchaToken = captchaRef.current?.getValue();
    login({ identifier, password, captchaToken });
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-6">
        <div className="card mt-5">
          <div className="card-body">
            <h2 className="text-center mb-4">Login</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={onSubmit}>
              <div className="form-group">
                <label>Username or Phone Number</label>
                <input
                  type="text"
                  name="identifier"
                  value={identifier}
                  onChange={onChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={onChange}
                  className="form-control"
                  required
                />
              </div>
              
              <div className="form-group d-flex justify-content-center mb-3">
                <ReCAPTCHA
                  ref={captchaRef}
                  sitekey="6LdbMBItAAAAANIKeytPp4ZTP46feFP68b2lVXpw"
                />
              </div>

              <button type="submit" className="btn btn-primary btn-block">Login</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
